<template>
    <div
        v-if="show"
        class="notification"
    >
        <div class="notification-content">
            <slot />
        </div>
        <div class="close-notification">
            <i
                class=" far fa-times"
                @click="hide"
            />
        </div>
    </div>
</template>

<script>
export default {
    // eslint-disable-next-line require-jsdoc
    data() {
        return {
            show: true,
        };
    },
    methods: {
        /**
         * Hides notification
         */
        hide() {
            this.show = false;
            this.$emit('hide-user-notification');
        },
    },
};
</script>
